export class BaseOrderWarning {
    constructor(orderEdit) {
        this.orderEdit = orderEdit;
    }
}
